import { jsPDF } from "jspdf";
import QRCode from "qrcode";
import { useLocation, useNavigate } from "react-router-dom";
import { Alert, Button, Modal } from "antd";
import { useEffect, useState } from "react";
export function PosSaleQrScreen() {
  const location = useLocation();
  const navigate = useNavigate();
  const esimUrl = (location.state as any)?.esimUrl;
  const subscriberId = (location.state as any)?.subscriberId;

  const [qrDataUrl, setQrDataUrl] = useState<string | null>(null);
  const [confirmModalVisible, setConfirmModalVisible] = useState(false);

  useEffect(() => {
    const generateQr = async () => {
      if (esimUrl) {
        const url = await QRCode.toDataURL(esimUrl);
        setQrDataUrl(url);
      }
    };

    generateQr();
  }, [esimUrl]);

  if (!esimUrl) {
    navigate("/plans");
    return null;
  }
  const generatePdf = async () => {
    const doc = new jsPDF();
  
    if (!qrDataUrl) return;
  
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const qrSize = 100;
    const centerX = (pageWidth - qrSize) / 2;
    const centerY = (pageHeight - qrSize) / 2;
  
    doc.addImage(qrDataUrl, 'PNG', centerX, centerY, qrSize, qrSize);
    doc.text('Scan the QR to activate your eSIM', pageWidth / 2, centerY + qrSize + 20, { align: 'center' });
  
    if (subscriberId) {
      doc.text(`Subscriber ID: ${subscriberId}`, pageWidth / 2, centerY + qrSize + 30, { align: 'center' });
    }
  
    window.open(doc.output('bloburl'), '_blank');
  };
  const handleBackClick = () => {
    setConfirmModalVisible(true);
  };

  const confirmBack = () => {
    setConfirmModalVisible(false);
    navigate("/plans");
  };

  const cancelBack = () => {
    setConfirmModalVisible(false);
  };

  return (
    <div style={{ padding: 24, textAlign: "center" }}>
      <h2>eSIM Ready!</h2>
      <Alert
        className="esim-share-notice"
        type="info"
        showIcon
        message="Share eSIM from Transactions -> Sales"
        description="After this sale, go to Transactions -> Sales and use the Share eSIM button to deliver it to the buyer."
      />

      {qrDataUrl ? (
        <div style={{ margin: "24px auto", width: 256, height: 256 }}>
          <img
            src={qrDataUrl}
            alt="QR Code"
            style={{ width: "100%", height: "100%" }}
          />
        </div>
      ) : (
        <p>Generating QR Code...</p>
      )}

      <Button type="primary" onClick={generatePdf} disabled={!qrDataUrl}>
        Open Printable PDF
      </Button>
      <Button style={{ marginLeft: 16 }} onClick={handleBackClick}>
        Back to Plans
      </Button>

      <Modal
        title="Are you sure?"
        open={confirmModalVisible}
        onOk={confirmBack}
        onCancel={cancelBack}
        okText="Yes, Go Back"
        cancelText="Stay Here"
      >
        <p>
          Before you close this window, please make sure that you already
          Printed or Scanned the QR code
        </p>
      </Modal>
    </div>
  );
}

export default PosSaleQrScreen;
